import Command from "@ckeditor/ckeditor5-core/src/command"

export default class InlineAdvertisementCommand extends Command {
  execute(options) {
    const id = options.id
    const description = options.description
    this.editor.model.change((writer) => {
      this.editor.model.insertContent(
        this.createInlineAdvertisement(writer, id, description)
      )
    })
  }

  refresh() {
    const model = this.editor.model
    const selection = model.document.selection
    const allowedIn = model.schema.findAllowedParent(
      selection.getFirstPosition(),
      "inlineAdvertisementBox"
    )

    this.isEnabled = allowedIn !== null
  }

  createInlineAdvertisement(writer, id, description) {
    const boxElement = writer.createElement("inlineAdvertisementBox")
    const labelElement = writer.createElement("inlineAdvertisementLabel")
    const descriptionElement = writer.createElement(
      "inlineAdvertisementDescription",
      { id: id }
    )
    writer.append(labelElement, boxElement)
    writer.append(descriptionElement, boxElement)
    if (id > 0) {
      // -1となるのはデフォルトインライン広告の場合
      const customScript = writer.createElement(
        "inlineAdvertisementCustomScript",
        { id: id }
      )
      writer.append(customScript, boxElement)
    }
    writer.appendText("インライン広告", labelElement)
    writer.appendText(description, descriptionElement)

    return boxElement
  }
}
